import { useEffect } from "react"
import { useChannel, useECommerceMachine } from "../../../_common/machines/machines-context"

export const useInitializeECommerceMachine = () => {
    const [, send] = useECommerceMachine()
    const channel = useChannel()
    const status = channel.status()

    useEffect(() => {
        if (status === "ready") {
            send({ type: "INITIALIZE" })
        }
    }, [send, status])
}
